<template>
  <div class="servicebox">
    <section id="banner">
      <div class="wrapper" :style="{background: 'url(' + categoryInfo.categoryPic + ') no-repeat center center'}"></div>
    </section>
    <section id="breadcrumb">
      <div class="wrapper">
        <img src="../assets/breadcrumb.png" />
        <router-link :to="{path: '/'}">回首页</router-link>&nbsp;&gt;&nbsp;
        <a>公司新闻</a>
      </div>
    </section>
    <section id="content">
      <span id="uiUpdatePanel_searchContent">
        <div class="wrapper">
          <h1 class="title">
            <span id="uiTag_title" langargument="Common,Tag,122">最新信息</span>
          </h1>
          <!-- <label>
            <span id="uiTag_Type" langargument="News,Tag,101">Type</span>
            <br />
            <select
              name="uiDrp_newsC_GUID"
              onchange="if (!window.__cfRLUnblockHandlers) return false; javascript:setTimeout('__doPostBack(\'uiDrp_newsC_GUID\',\'\')', 0)"
              id="uiDrp_newsC_GUID"
            >
              <option selected="selected" value>Select All</option>
              <option value="53a8f7b2-b90e-4399-82d2-96d35cd8424c">新聞稿</option>
              <option value="03f1aac7-0673-4cb4-b983-b2595e7eee55">产业观点</option>
            </select>
          </label> -->
          <label>
            <span id="uiTag_Year" langargument="News,Tag,102">年度</span>
            <br />
            <select
              name="uiDrp_Year"
              v-model="listQuery.year"
              @change="getNews"
            >
              <option value>Select All</option>
              <option v-for="(item, index) in yearList" :key="index" :value="item">{{item}}</option>
            </select>
          </label>
          <div id="items">
            <div v-for="(item, index) in newsList" :key="index" class="item">
              <span class="date">{{item.createTime}}</span>
              <a
                @click="gotocnew_detail(item.id)"
                id="ui_dglistview_uiHref_newsDetail_02_0"
                class="itemTitle_pej"
              >{{item.title}}</a>
            </div>
            
          </div>
          <div id="pages"></div>
        </div>
      </span>
    </section>
  </div>
</template>

<script type="text/ecmascript-6">
import { getContentList, getCategoryInfo } from "@/api/content";
export default {
  name: "",
  data() {
    return {
      msg: "这是我的",
      newsList: [],
      categoryId: this.$route.query.categoryId,
      listQuery: {
        year: null,
        size: 10,
        current: 1
      },
      yearList: [],
      categoryInfo: {}
    };
  },
  methods: {
    getBanner() {
      // console.log(this.categoryId)
      getCategoryInfo(this.categoryId).then(res => {
        if (res.code !== 200) return
        this.categoryInfo = res.data
        this.categoryInfo.categoryPic = process.env.BASE_API + '/web' + this.categoryInfo.categoryPic
      })
    },
    gotocnew_detail(e) {
      this.$router.push({ path: "/cnDetail", query: { id: e, categoryId: this.categoryId } });
      window.location.reload();
    },
    getNews() {
      getContentList(this.listQuery).then(res => {
        if (res.code !== 200) return
        this.newsList = res.data.records
      })
    }
  },
  mounted() {
    let nowYear = new Date().getFullYear()
    for (let index = 0; index < 5; index++) {
      this.yearList.push(nowYear - index)
    }
    this.listQuery.year = nowYear
    this.listQuery.categoryId = this.categoryId
    this.getNews()
    this.getBanner()
  },
};
</script>

<style scoped >
#banner .wrapper {
  position: relative;
  width: 100%;
  height: 240px;
  box-sizing: border-box;
  background: url(../assets/20170519-17081289.jpg) center top no-repeat;
  background-size: 100% auto;
}
#banner .wrapper {
  background-size: auto 100% !important;
}
section .wrapper {
  width: 1280px;
  margin: 0 auto;
  box-sizing: border-box;
  text-align: center;
  overflow: hidden;
}
@media screen and (max-width: 760px) {
  section#banner .wrapper {
    height: 140px;
  }
}
@media screen and (max-width: 1000px) {
  section .wrapper {
    width: 100%;
  }
}
@media screen and (max-width: 1000px) {
  #banner .wrapper {
    background-size: auto 100%;
  }
}

section#breadcrumb {
  width: 100%;
  color: #fff;
  background: #c8c9cb;
}
@media screen and (max-width: 760px) {
  section#breadcrumb .wrapper {
    padding: 10px;
    font-size: 12px;
  }
}
#breadcrumb .wrapper {
  padding: 13px 40px;
  line-height: 16px;
  text-align: left;
  font-size: 14px;
  color: #333;
}
#breadcrumb .wrapper img {
  vertical-align: top;
  margin-right: 5px;
}
img {
  border: none;
  max-width: 100%;
  vertical-align: middle;
}
#breadcrumb .wrapper a {
  color: #333;
}
@media screen and (max-width: 1000px) {
  section#content .wrapper {
    width: 100%;
    padding: 40px 20px;
  }
}
#content .wrapper {
  width: 960px;
  padding: 40px 0;
  text-align: left;
  box-sizing: border-box;
}
@media screen and (max-width: 1300px) {
  .servicebox section .wrapper {
    width: 100%;
  }
}

@media screen and (max-width: 1120px) {
  section#content .wrapper {
    width: 100%;
    padding: 40px 20px;
  }
}
#content .wrapper {
  width: 1100px;
  padding: 40px 20px;
  text-align: left;
  box-sizing: border-box;
}
@media screen and (max-width: 1300px) {
  section .wrapper {
    width: 100%;
  }
}

#content .wrapper .title {
  font-size: 24px;
  color: #146cbd;
  padding: 20px 0;
  border-bottom: 1px #ccc solid;
  margin-bottom: 40px;
  font-family: "LatoWeb";
}
@media screen and (max-width: 760px) {
  #content .wrapper label {
    margin-right: 10px;
  }
}
#content .wrapper label {
  display: inline-block;
  font-family: "LatoWebBold";
  font-size: 16px;
  line-height: 30px;
  margin-right: 20px;
}
@media screen and (max-width: 760px) {
  #content .wrapper label select {
    min-width: 150px;
  }
}
#content .wrapper label select {
  padding: 10px;
  min-width: 200px;
  display: inline-block;
}
#content .wrapper #items {
  margin: 40px 0;
}
#content .wrapper .item {
  border-top: 1px #ccc solid;
  padding: 30px 0;
  line-height: 26px;
  font-family: "LatoWebBold";
  font-size: 15px;
  color: #666;
}
#content .wrapper .item a {
  color: #666;
}
#content .wrapper .item:hover a {
  color: #146cbd;
}
#content .wrapper .item .date {
  display: inline-block;
  margin-right: 30px;
  font-weight: bold;
}
#content .wrapper .item .itemTitle_pej {
  font-family: "LatoWebBold";
  font-size: 15px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/pages/cnews.vue